import { Box, Text } from '@chakra-ui/react'
import React from 'react'

export const CustomSwitch = ({
  isChecked,
  onChange,
  onText = 'ON',
  offText = 'OFF'
}: {
  isChecked: boolean
  onChange: () => void
  onText?: string
  offText?: string
}) => {
  return (
    <Box
      position="relative"
      display="inline-block"
      w="48px"
      h="20px"
      bg={isChecked ? '#2D54E8' : '#A1A1A1'}
      borderRadius="12px"
      cursor="pointer"
      transition="all 0.2s"
      onClick={onChange}
    >
      <Box
        position="absolute"
        top="2px"
        left={isChecked ? '30px' : '2px'}
        w="16px"
        h="16px"
        bg="white"
        borderRadius="50%"
        transition="all 0.2s"
        boxShadow="0 1px 3px rgba(0,0,0,0.2)"
      />
      <Text
        position="absolute"
        top="50%"
        left={isChecked ? '4px' : 'auto'}
        right={isChecked ? 'auto' : '4px'}
        transform="translateY(-50%)"
        fontSize="xs"
        fontWeight="bold"
        color="white"
        userSelect="none"
        pointerEvents="none"
      >
        {isChecked ? onText : offText}
      </Text>
    </Box>
  )
}
